/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, HostListener, OnInit } from '@angular/core';
import { SharedModule } from '../../shared/shared.moudle';
import { AuthenticationService } from '../../../services/authentication.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { STATUS_ACTIVE } from '../../../data-models/user-login';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    SharedModule,
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent implements OnInit {
  resetForm: FormGroup | any;
  show = false;
  submmited = false;
  notRegistered = false
  fetchedToken: any = ""
  isSubmitting: boolean = false;

  constructor(
    private auth: AuthenticationService,
    private router: Router,
    private toastr: ToastrService
  ) { }


  ngOnInit(): void {
    this.resetForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    })
  }

  @HostListener('window:offline')
  onOffline() {
    if (this.isSubmitting) {
      this.isSubmitting = false;
      this.toastr.error("No internet connection. Please check your network and try again.", 'No Internet', {
        progressBar: true,
        closeButton: true
      });
    }
  }

  @HostListener('window:online')
  onOnline() {
    this.toastr.success("You're back online. You can try again.", 'Connected', {
      progressBar: true,
      closeButton: true
    });
  }

  private notifyNetworkOrServerError(err: any) {
    if (!navigator.onLine || err?.status === 0) {
      this.toastr.error("No internet connection. Please check your network and try again.", 'No Internet', {
        progressBar: true,
        closeButton: true
      });
    } else {
      this.toastr.error("Something went wrong. Please try again.", 'Request Failed', {
        progressBar: true,
        closeButton: true
      });
    }
  }

  onReset() {
    this.submmited = true
    if (this.isSubmitting) {
      return;
    }
    if (!navigator.onLine) {
      this.toastr.error("No internet connection. Please check your network and try again.", 'No Internet', {
        progressBar: true,
        closeButton: true
      });
      return;
    }
    if (this.resetForm.valid) {
      this.isSubmitting = true;
      this.login(this.resetForm.controls.email.value.trim().toLowerCase())
    }
  }

  login(email: any) {
    this.auth.checkEmail(email.trim().toLowerCase()).subscribe({
      next: (result) => {
        if (result.active_status === STATUS_ACTIVE) {
          this.auth.generateToken(email.trim().toLowerCase()).subscribe({
            next: (res) => {
              this.auth.sendMailToResetPassword(res.token, email.trim().toLowerCase()).subscribe({
                next: () => {
                  this.toastr.success("Password reset link is sent to your registered email.", 'Password Reset Link', {
                    progressBar: true,
                    closeButton: true
                  })
                  this.router.navigate(['user/send']);
                },
                error: (err) => {
                  console.error(err);
                  this.notifyNetworkOrServerError(err);
                  this.isSubmitting = false;
                },
                complete: () => {
                  this.isSubmitting = false;
                }
              })
            },
            error: (err) => {
              console.error(err);
              this.notifyNetworkOrServerError(err);
              this.isSubmitting = false;
            }
          })
        } else if (result['error'] === "no results found") {
          this.notRegistered = true
          this.toastr.warning("Your email account is not registered.", 'Wrong Email', {
            progressBar: true,
            closeButton: true
          })
          this.notRegistered = true
          this.isSubmitting = false;
        } else {
          this.toastr.warning("Your account has been deactivated. Contact Dartle support.", 'Warning', {
            progressBar: true,
            closeButton: true
          })
          this.isSubmitting = false;
        }
      },
      error: (error) => {
        console.log(error)
        this.notifyNetworkOrServerError(error);
        this.isSubmitting = false;
      }
    })
  }
}
